/*jshint esversion: 6 */

const expr = require('./lib');

module.exports = expr;
